export default __webpack_public_path__ + "static/media/מועמדים-פוטושופ---סופי_0005s_0000_Black-&-White-4.ef712bf0.png";